<div class="row">
  <div class="col-md-12">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
      <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
        <mat-card-title class="mat-mdc-card-title text-white">
          {{ 'MakeSectorsOrder'|translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="mat-mdc-card-content text-center">
                <span class="tilte">{{ 'TotalOrder'|translate }} : {{ totalOrderCost| number : '1.2' }} {{
                    'EGP' | translate
                  }}</span>
        <div class="row">
          <div class="col-lg-4 m-t-20 m-b-15"
               *ngFor="let ingredient of OrderInfoData.ingredientsInfo;let i=index">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
              <mat-card-content class="mat-mdc-card-content text-center">
                <div class="row">
                  <div class="col-md-4">
                    <img class="m-auto ms-5 product-img"
                         src="{{ingredient?.product?.tblProductName?.imgURL | image_placeholder}}">
                    <!-- <img width="80" height="50" class="m-auto ms-5"
                src="{{ingredient?.product?.tblProductName?.imgURL | adjust_image_path}}"> -->
                  </div>
                  <div class="col-md-8">
                                        <span class="TypeName">
                                          <span >{{ ingredient?.product?.tblProductName?.name }}</span>
                                             -
                                          {{ ingredient?.product?.tblColors?.colorName }}
                                        </span>

                    <table class="w-100 m-b-20">
                      <tbody>
                      <tr>
                        <td>
                          <span>{{ ingredient.numRollsUsed }} </span>
                          <span>{{ 'Oud'|translate }} </span>
                        </td>
                        <td>
                                                        <span>
                                                            {{ ingredient.totalByDescount }}
                                                          {{ 'EGP' | translate }}
                                                        </span>
                        </td>
                      </tr>

                      </tbody>
                      <tfoot>
                      <mat-divider style="width: 200%;"></mat-divider>
                      <tr>
                        <td>
                          <span>{{ 'total'|translate }} </span>
                        </td>
                        <td>
                                                        <span>
                                                            {{ ingredient.totalByDescount }}
                                                          {{ 'EGP' | translate }}
                                                        </span>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div class="col-md-12 trBtn">
                    <mat-divider style="margin-bottom: 15px;"></mat-divider>
                    <a class="btnDelete" (click)="Delete(ingredient?.product?.productId)">
                      {{ 'delete' | translate }}
                    </a>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-lg-4 m-t-20 m-b-15"
               *ngFor="let ingredient of OrderInfoData.accessoriesInfo;let i=index">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
              <mat-card-content class="mat-mdc-card-content text-center">
                <div class="row">
                  <div class="col-md-4">
                    <img class="m-auto ms-5 product-img"
                         src="{{ingredient?.product?.tblProductName?.imgURL | image_placeholder}}">
                    <!-- <img width="80" height="50" class="m-auto ms-5"
                src="{{ingredient?.product?.tblProductName?.imgURL | adjust_image_path}}"> -->
                  </div>
                  <div class="col-md-8">
                                        <span class="TypeName">
                                            {{ ingredient?.product?.tblProductName?.name }} -
                                          {{ ingredient?.product?.tblColors?.colorName }}
                                        </span>

                    <table class="w-100 m-b-20">
                      <tbody>
                      <tr>
                        <td>
                          <span>{{ ingredient.product?.measruingUnit }} </span>
                          <span>{{ ingredient.count }} </span>
                        </td>
                        <td>
                                                        <span>
                                                            {{ ingredient.totalByDescount }}
                                                          {{ 'EGP' | translate }}
                                                        </span>
                        </td>
                      </tr>

                      </tbody>
                      <tfoot>
                      <mat-divider style="width: 200%;"></mat-divider>
                      <tr>
                        <td>
                          <span>{{ 'total'|translate }} </span>
                        </td>
                        <td>
                                                        <span>
                                                            {{ ingredient.totalByDescount }}
                                                          {{ 'EGP' | translate }}
                                                        </span>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div class="col-md-12 trBtn">
                    <mat-divider style="margin-bottom: 15px;"></mat-divider>
                    <a class="btnDelete" (click)="Delete(ingredient?.product?.productId)">
                      {{ 'delete' | translate }}
                    </a>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="calc-cost-actionbar">
            <button class="btn orangecolorbtn" *ngIf="OrderInfoData.ingredientsInfo" (click)="exportPDF()">
              {{ 'exportPDF'|translate }}
            </button>

            <button class="btn colorbtn" *ngIf="OrderInfoData.ingredientsInfo" (click)="AddNewInvoices()">
              {{ 'SendOrder'|translate }}
            </button>

            <button class="btn redbtn" *ngIf="OrderInfoData.ingredientsInfo"
                    (click)="DeleteOrder()">{{ 'DeleteOrder'|translate }}
            </button>

            <a (click)="Cancel()" class="btn btnClose">
              {{ 'Back' | translate }}
            </a>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
